import { useMyPaymentTermsWithPending } from "@/api/use-invoices";
import { PendingInvoiceCard } from "./pending-invoice-card";
import { CustomerInvoicesTable } from "./customer-invoices-table";
import { PageHeader, HairlineStats } from "@/components/page-chrome";
import { useTranslation } from "react-i18next";

function formatCurrency(cents: number): string {
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
  }).format(cents / 100);
}

export default function InvoicesScreen() {
  const { t } = useTranslation("app");
  const { data } = useMyPaymentTermsWithPending();
  const usage = data?.creditUsage;
  const open = usage?.outstandingBalance ?? 0;
  const limit = usage?.creditLimit ?? 0;
  const available = data?.availableCredit ?? Math.max(limit - open, 0);

  return (
    <div className="space-y-9">
      <PageHeader
        eyebrow={t("invoices.eyebrow")}
        title={t("invoices.title")}
        italic={t("invoices.italic")}
        lede={t("invoices.lede")}
      />

      {limit > 0 && (
        <HairlineStats
          items={[
            {
              value: formatCurrency(open),
              label: t("invoices.stats.openBalance"),
              accent: open > 0 ? "primary" : undefined,
            },
            {
              value: formatCurrency(limit),
              label: t("invoices.stats.creditLimit"),
            },
            {
              value: formatCurrency(available),
              label: t("invoices.stats.availableCredit"),
              accent: available > 0 ? "success" : undefined,
            },
          ]}
        />
      )}

      <PendingInvoiceCard />

      <CustomerInvoicesTable />
    </div>
  );
}
